var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"color":"#000","opacity":"0.5","z-index":9999,"value":_vm.value,"absolute":""}},[_c('v-progress-circular',{attrs:{"color":"#ccc","indeterminate":"","size":"128"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }